import React, { Component } from "react";
import { Container, Button, ModalBody, Row, Col, Modal } from "reactstrap";
import MultiSelect from "@khanacademy/react-multi-select";
import ErrorTokenMiss from "../../components/ErrorTokenMiss/ErrorTokenMiss";
export default class ChromePrint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPrinters: [],
      printers: [],
      tokenMissmatchModalVisible: false,
      tokenErrorMessage: ""
    };
  }

  componentDidMount() {
    const GNGPrinters = localStorage.getItem("GNGPrinters");

    if (GNGPrinters !== null) {
      let str1 = JSON.parse(JSON.stringify(GNGPrinters));

      var array = str1.split(",");
      let internalArray = [];
      for (let i = 0; i < array.length; i++) {
        internalArray.push({
          label: array[i],
          value: array[i]
        });
      }

      this.setState({
        printers: internalArray
      });
    }
  }
  render() {
    return (
      <Container fluid style={{ padding: 0, margin: 0, alignItems: "center" }}>
        <Modal
          size="lg"
          isOpen={this.state.tokenMissmatchModalVisible}
          toggle={this.toggleErrorTokenMissModal}
        >
          <ErrorTokenMiss
            editable={true}
            tokenErrorMessage={this.state.tokenErrorMessage}
            goBack={this.toggleErrorTokenMissModal}
          />
        </Modal>
        <ModalBody>
          <div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 15,
                paddingBottom: 10,
                borderBottom: "1px solid #ECECEC"
              }}
            >
              <p>Printers List </p>

              <Button
                style={{ color: "white", backgroundColor: "red" }}
                onClick={this.props.goBack}
              >
                {" "}
                Back
              </Button>
            </div>
            <Row>
              <Col
                xs="12"
                sm="12"
                md="4"
                lg="4"
                style={{ display: "flex", alignItems: "center" }}
              >
                <div style={{ padding: 10, width: "100%" }}>
                  <MultiSelect
                    overrideStrings={{
                      selectSomeItems: "Select Printers",
                      allItemsAreSelected: this.state.selectedPrinters,
                      selectAll: "Select All",
                      search: "Search"
                    }}
                    options={this.state.printers}
                    selected={this.state.selectedPrinters}
                    onSelectedChanged={selected => {
                      this.handleChangePrinters(selected);
                    }}
                  />
                </div>
              </Col>
            </Row>
            <Button
              color="success"
              style={{ color: "white", marginLeft: 15 }}
              onClick={() => {
                this.selectedPrintersHandled();
              }}
            >
              {" "}
              Submit
            </Button>
          </div>
        </ModalBody>
      </Container>
    );
  }
  selectedPrintersHandled = () => {
    localStorage.setItem("gngPrintersSelected", this.state.selectedPrinters);
    this.toggleErrorTokenMissModal("Successfully updated!");
  };
  toggleErrorTokenMissModal = text => {
    this.setState({
      tokenMissmatchModalVisible: !this.state.tokenMissmatchModalVisible,
      tokenErrorMessage: text
    });
  };
  // <ModalFooter>
  //   <div>
  //     <Button
  //       color="success"
  //       onClick={() => {
  //         this.props.goBack();
  //       }}
  //     >
  //       Ok
  //     </Button>{" "}
  //   </div>
  // </ModalFooter>
  handleChangePrinters = selected => {
    this.setState({
      selectedPrinters: selected
    });
  };
}



// WEBPACK FOOTER //
// ./src/components/ChromePrint/ChromePrint.js